export const Icons = {
  board: require('./board.svg'),
  finger: require('./finger.svg'),
}
